package com.zi.support.web

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLLinkElement
import org.w3c.dom.HTMLScriptElement

/**
 * More > User guides: hosting/guides/guides.js draws the guides (the same code the Android and iOS screens show)
 * straight into this page, styled by guides.css with this app's own colour tokens. Loaded once, on first open.
 */
internal object GuidesScreen {
    private var loaded = false

    fun render() {
        element("content")?.innerHTML = "$MORE_BACK<div class=\"page-intro\"><div><h2>User guides</h2>" +
            "<p>How to use each of our apps, step by step. Every guide ends with a quick quiz and can be downloaded as a PDF.</p></div></div>" +
            "<div id=\"ug\"><div class=\"page-spinner\" role=\"status\" aria-label=\"Loading\"></div></div>"
        bindMoreBack()
        if (loaded) { draw(); return }
        val css = document.createElement("link") as HTMLLinkElement
        css.rel = "stylesheet"
        css.href = "/guides/guides.css"
        document.head?.appendChild(css)
        val script = document.createElement("script") as HTMLScriptElement
        script.src = "/guides/guides.js"
        script.onload = { loaded = true; draw() }
        script.onerror = { _, _, _, _, _ -> element("ug")?.innerHTML = "<div class=\"empty\">The guides couldn't be loaded. Check your connection, then open User guides again.</div>"; null }
        document.head?.appendChild(script)
    }

    private fun draw() {
        val root = element("ug") ?: return
        root.innerHTML = ""
        window.asDynamic().Guides.render(root, json("pdf" to "/guides/pdf/"))
    }
}
